import { NgModule } from '@angular/core';
import { NzNotificationModule } from 'ng-zorro-antd';

import { AtxNotificationService } from './services';

@NgModule({
    imports: [
        NzNotificationModule,
    ],
    providers: [
        AtxNotificationService,
    ]
})

export class AtxNotificationModule {}
